import PropTypes from 'prop-types'

function ToggleSidebarButton({ isSidebarOpen, setIsSidebarOpen, className }) {
  return (
    <button
      type="button"
      className={`${
        isSidebarOpen ? '' : 'md:rounded-lg'
      } ${className} md:rounded-t-lg flex items-center justify-between sm-down:w-full px-6 py-4 font-bold text-white bg-brand-red transition-colors hover:bg-brand-yellow`}
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    >
      <span>{isSidebarOpen ? 'Hide' : 'Show'} Filters</span>

      {isSidebarOpen ? (
        <svg viewBox="0 0 20 11" className="w-5 h-3">
          <path
            d="M9.248.153L.153 9.248a.522.522 0 000 .739l.86.86a.522.522 0 00.739 0l7.866-7.849 7.866 7.849a.522.522 0 00.738 0l.86-.86a.522.522 0 000-.739L9.987.153a.522.522 0 00-.739 0z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 20 11" className="w-5 h-3">
          <path
            d="M9.987 10.847l9.095-9.095a.522.522 0 000-.739l-.86-.86a.522.522 0 00-.738 0L9.618 8.002 1.752.153a.522.522 0 00-.739 0l-.86.86a.522.522 0 000 .739l9.095 9.095a.522.522 0 00.739 0z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </svg>
      )}
    </button>
  )
}

ToggleSidebarButton.propTypes = {
  isSidebarOpen: PropTypes.bool,
  setIsSidebarOpen: PropTypes.func,
  className: PropTypes.string,
}

export default ToggleSidebarButton
